// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Date$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as CorePricingViewUtils from "../../../library/utils/CorePricingViewUtils.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TooltipComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/tooltip/TooltipComponent.bs.js";

function EligibilityRulesCard$ClusterAndZoneDescription(Props) {
  var info = Props.info;
  var tool_tip = info.tool_tip_content;
  if (tool_tip !== undefined) {
    return React.createElement("div", {
                className: "cluster-zone-tool-tip"
              }, React.createElement("div", undefined, info.content), React.createElement(TooltipComponent$Catalyst.make, {
                    content: tool_tip.content,
                    placement: /* Top_End */10,
                    children: React.createElement("div", {
                          className: "popper"
                        }, tool_tip.title)
                  }));
  } else {
    return React.createElement("div", undefined, info.content);
  }
}

var ClusterAndZoneDescription = {
  make: EligibilityRulesCard$ClusterAndZoneDescription
};

function EligibilityRulesCard(Props) {
  var eligibility_rules = Props.eligibility_rules;
  return React.createElement(CardComponent$Catalyst.make, {
              className: "modification-basic-primary-info-card",
              children: null
            }, React.createElement(CorePricingViewUtils.LineItem.make, {
                  label: "Start Time",
                  unit: "hh:mm",
                  value: Date$Catalyst.toString("HH:mm", eligibility_rules.start_time)
                }), React.createElement(CorePricingViewUtils.LineItem.make, {
                  label: "End Time",
                  unit: "hh:mm",
                  value: Date$Catalyst.toString("HH:mm", eligibility_rules.end_time)
                }), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(CorePricingViewUtils.LineItem.make, {
                  label: "Repeat On Day(s)",
                  value: eligibility_rules.repeat_days
                }), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Pickup Cluster(s)"), React.createElement(EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.pick_up_cluster
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Pickup Zone(s)"), React.createElement(EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.pick_up_zone
                    })), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Drop Cluster(s)"), React.createElement(EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.drop_cluster
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", undefined, "Drop Zone(s)"), React.createElement(EligibilityRulesCard$ClusterAndZoneDescription, {
                      info: eligibility_rules.drop_zone
                    })));
}

var make = EligibilityRulesCard;

export {
  ClusterAndZoneDescription ,
  make ,
  
}
/* react Not a pure module */
